import repository from '@/api/Main/notificationSettings'

export default {
    state: {
        notification_settings:      [],
        notification_departments:   [],
        notification_settings_loading: false,
    },

    getters: {
        GET_NOTIFICATION_SETTINGS:    (state) => state.notification_settings,
        GET_NOTIFICATION_DEPARTMENTS: (state) => state.notification_departments,
        NOTIFICATION_SETTINGS_LOADING:(state) => state.notification_settings_loading,
    },

    mutations: {
        SET_NOTIFICATION_SETTINGS(state, { data, departments }) {
            state.notification_settings    = data
            state.notification_departments = departments
        },
        UPDATE_NOTIFICATION_SETTING(state, updated) {
            const idx = state.notification_settings.findIndex(s => s.id === updated.id)
            if (idx !== -1) state.notification_settings.splice(idx, 1, updated)
        },
        SET_NOTIFICATION_SETTINGS_LOADING(state, val) {
            state.notification_settings_loading = val
        },
    },

    actions: {
        async fetchNotificationSettings({ commit }) {
            commit('SET_NOTIFICATION_SETTINGS_LOADING', true)
            try {
                const res = await repository.index()
                commit('SET_NOTIFICATION_SETTINGS', {
                    data:        res.data.data,
                    departments: res.data.departments,
                })
            } finally {
                commit('SET_NOTIFICATION_SETTINGS_LOADING', false)
            }
        },

        async updateNotificationSetting({ commit }, { id, payload }) {
            const res = await repository.update(id, payload)
            commit('UPDATE_NOTIFICATION_SETTING', res.data.data)
            return res.data
        },

        async postAnnouncement(_, payload) {
            const res = await repository.postAnnouncement(payload)
            return res.data
        },
    },
}
